import api from './api';

const proveedorService = {
  listar: async () => {
    const { data } = await api.get('/proveedores');
    return data.data;
  },

  crear: async (proveedor) => {
    const { data } = await api.post('/proveedores', proveedor);
    return data.data;
  },

  actualizar: async (id, proveedor) => {
    const { data } = await api.put(`/proveedores/${id}`, proveedor);
    return data.data;
  },

  eliminar: async (id) => {
    await api.delete(`/proveedores/${id}`);
  },
};

export default proveedorService;